import React from 'react';
import HeaderSection from "../headerSection/HeaderSection";


 function MehmanSara() {
  return (
    <div>
            <HeaderSection></HeaderSection>

<p>مهمانسرا</p>
    </div>
  )
}
export default MehmanSara;